module.exports = __webpack_public_path__ + "img/clearance-homepage-deal-desktop-compressed.0236e13.png";